import React from "react";

import BasicNavbar from "./BasicNavbar";
import SiteFooter from "../../components/SiteFooter";

export default function TermsOfServicePage() {
  return (
    <div className="dark">
      <div className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden overflow-y-auto scroll-smooth">
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col items-center pt-[calc(6rem+var(--intl-notice-height,0px))] pb-24">
          <section className="w-full max-w-5xl px-6 sm:px-8">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight sm:text-[32px]">
              服务条款
            </h1>
            <div className="text-default-500 mt-4 space-y-6 text-sm leading-relaxed sm:text-base">
              <section>
                <p>
                  欢迎使用 3Chat.ai！
                </p>
                <p className="mt-2">
                  本《服务条款》（以下简称“本条款”）由您（“用户”或“客户”）与上海纽酷信息科技有限公司（以下简称“3Chat.ai”、“我们”）订立，用于规范您访问和使用 3Chat.ai 产品及相关服务。当您点击“同意”或使用本服务，即表示您已阅读、理解并同意遵守本条款及《隐私政策》。若您代表公司或其他组织使用本服务，您承诺已获得充分授权。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">1. 服务内容</h2>
                <p>
                  3Chat.ai 提供智能客服软件及相关 SaaS 服务，包括但不限于不同订阅版本（如 Starter、Growth、Pro、Enterprise）、标准化实施服务与可选客户化开发服务。
                </p>
                <p className="mt-2">
                  订阅服务的具体功能、配额与限制以购买页面与订单明细为准。实施与客户化开发服务的范围、交付物与验收标准以双方订单或工作说明书（SOW）约定为准。
                </p>
                <p className="mt-2">
                  未经 3Chat.ai 书面授权，用户不得转让、转租、转售或以其他形式共享服务访问权限。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">2. 订阅与付款</h2>
                <p>
                  <span className="font-medium text-foreground">价格与税务：</span>
                  所有在官网、报价或订单中标示的价格/合同金额为含税金额（即包含按当时适用税率计算的税费），除非订单中另有明确说明。发票与税率以开票时点为准；若国家税收政策变更，开票税率按开票时点执行，但合同总金额不变（以双方签署的合同条款为准）。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">币种与付款：</span>
                  订单默认以人民币计价，付款方式可为线上支付（支持的平台/渠道以系统支持为准）或对公转账。收款账户信息以订单或付款指引为准。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">是否退费：</span>
                  除法律法规另有强制性规定或双方另有书面约定外，订阅及服务费用一经支付（且服务已按订单开通或已履行相应交付义务），一般不予退还。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">发票：</span>
                  3Chat.ai 按照订单约定与税务规则开具电子发票（数电票），并将发票发送至订单或系统中登记的邮箱。发票类型与开具时间以订单（或系统配置）为准。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">3. 续费与到期处理</h2>
                <p>
                  <span className="font-medium text-foreground">续费提醒：</span>
                  3Chat 将在订阅到期前向客户提供续期提醒（合同/条款中普遍为“剩余订阅期限不足一个月时提醒”）。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">默认行为：</span>
                  除用户在购买/账户中明确选择并授权自动续费外，订阅服务不默认自动续订；服务到期后系统将自动关闭相应服务。若用户选择自动续费，系统将事前在购买页面明示并提供取消方式。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">到期数据保留：</span>
                  订阅服务到期后，3Chat 将在合理期限内（通常合同中约定为最长 30 个自然日）提供数据保留/迁移通道；逾期未处理的，3Chat 有权按约或按系统规则清理数据或另行收取保管费用。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">4. 数据与隐私</h2>
                <p>
                  <span className="font-medium text-foreground">数据所有权：</span>
                  客户在服务中产生的数据（“客户数据”）归客户所有。3Chat.ai 在为履行服务过程中收集、处理和存储客户数据，遵循已公布的《隐私政策》及适用法律。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">响应司法/监管要求：</span>
                  在法律或行政/司法机关要求下，3Chat.ai 可能依法提供客户或用户信息并不另行通知。
                </p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">安全与备份：</span>
                  3Chat.ai 将采取合理技术和管理措施确保数据安全，并在可行条件下提供备份与恢复支持；但对第三方服务商造成的不可用或数据损失，依具体合同另行约定或按法律规定处理。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">5. 知识产权</h2>
                <p>
                  3Chat.ai 拥有本服务软件、文档、商标、源代码等全部知识产权。用户仅在订阅期间取得有限、非独占、不可转让的使用权。
                </p>
                <p className="mt-2">
                  对于用户在服务中上传的内容，用户保证其拥有相应权利并授权 3Chat 在提供服务范围内使用该等内容（具体授权范围以合同或服务条款为准）。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">6. 服务可用性与支持</h2>
                <p>
                  3Chat.ai 将尽商业上合理努力保证服务的持续可用性并及时处理故障，但不在本条款中承诺具体数值型 SLA（如具体可用率），除非双方另行签署 SLA 或在订单中明确约定。
                </p>
                <p className="mt-2">
                  支持等级、响应时间与联系方式依据用户所购买的订阅级别或服务协议约定执行。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">7. 期限、暂停与终止</h2>
                <p>
                  本条款自用户开始使用服务或下单之日起生效。若用户违反本条款或相关协议，3Chat.ai 有权在通知或无需通知的情形下暂停或终止其服务权利并追究相应责任。
                </p>
                <p className="mt-2">
                  若服务被终止，用户应停止使用服务并仍需支付到期应付费用；已支付费用的处理以双方约定或法律规定为准。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">8. 责任限制与免责声明</h2>
                <p>
                  服务按“现状”提供。3Chat.ai 不就服务适销性、特定用途适用性作出明示保证（但不排除法律强制性规定另有要求）。
                </p>
                <p className="mt-2">
                  在法律允许的范围内，3Chat.ai 对任何间接、特殊、附带或后果性损失不承担责任；对直接损失的总体赔偿责任以用户在被索赔前 12 个月内向 3Chat.ai 已支付的服务费用为上限（具体以双方合同约定为准）。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">9. 保密</h2>
                <p>
                  双方应对在提供/接受服务过程中获悉的对方非公开信息予以保密，除为提供服务或法律要求外不得披露。保密义务期限以双方合同约定为准。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">10. 争议解决与适用法律</h2>
                <p>
                  本条款的订立、解释与执行适用中华人民共和国法律。双方应首先友好协商解决争议；协商不成的，任何一方可向 3Chat.ai 所在地有管辖权的人民法院提起诉讼（或按双方合同另有约定的争议解决方式处理）。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">11. 其他</h2>
                <p>
                  本条款与《隐私政策》《订阅协议》《服务协议》及双方已签署之订单共同构成完整协议；如存在冲突，应以订单或双方书面约定为准。
                </p>
                <p className="mt-2">
                  3Chat 可不定期修订本条款，修订内容将通过网站公告或系统提示发布；若您在修订后继续使用服务，则视为接受修订。
                </p>
                <p className="mt-2">
                  联系方式：<span className="font-medium text-foreground">contact@3chatai.com</span>
                </p>
                <p className="mt-4 text-foreground">© 2025 上海纽酷信息科技有限公司 版权所有</p>
              </section>
            </div>
          </section>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

